import { ReadOnlyField } from '@app/components/various/Fields/ReadOnlyField';
import { FieldLabel } from '@app/components/various/Form';
import { getCheckoutFields } from '@app/ducks';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

interface Props {
  poNumber?: string;
}

export const CheckoutSuccessPoNumber = ({ poNumber = '' }: Props) => {
  const checkoutFields = useSelector(getCheckoutFields);
  const { t } = useTranslation(['checkout']);
  const shouldShowPoNumber = 'poNumber' in checkoutFields;

  if (!shouldShowPoNumber) {
    return null;
  }

  return (
    <div className="box">
      <div className="flex flex-col gap-x-5 gap-y-1 md:flex-row md:items-center">
        <FieldLabel as="div" label={t('checkout:po_number')} className="w-full">
          <ReadOnlyField className="w-full">{poNumber || '-'}</ReadOnlyField>
        </FieldLabel>
      </div>
    </div>
  );
};
